var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"document-page fixed-draggable-dynamic-table-wrapper-height"},[_c('draggable-dynamic-table',{ref:"documentsTransactionsList",attrs:{"options":_vm.options,"columns":_vm.columnsLabel,"data":_vm.data,"zero-top-radius":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }